module.exports = __webpack_public_path__ + "media/images/elements/Elemntas_2-050b03bed75319bf3b89412471ca710e.svg";